const ArtistMenuIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M5.89474 28C4.78947 28 3.69649 27.7146 2.61579 27.1439C1.53509 26.5731 0.663158 25.8208 0 24.8868C0.638597 24.8868 1.28947 24.6209 1.95263 24.0891C2.61579 23.5572 2.94737 22.7854 2.94737 21.7736C2.94737 20.4765 3.37719 19.3739 4.23684 18.4659C5.09649 17.5579 6.14035 17.1038 7.36842 17.1038C8.59649 17.1038 9.64035 17.5579 10.5 18.4659C11.3596 19.3739 11.7895 20.4765 11.7895 21.7736C11.7895 23.4859 11.2123 24.9517 10.0579 26.171C8.90351 27.3903 7.51579 28 5.89474 28ZM5.89474 24.8868C6.70526 24.8868 7.39912 24.582 7.97632 23.9723C8.55351 23.3626 8.84211 22.6298 8.84211 21.7736C8.84211 21.3326 8.70088 20.9629 8.41842 20.6646C8.13597 20.3662 7.78596 20.217 7.36842 20.217C6.95088 20.217 6.60088 20.3662 6.31842 20.6646C6.03596 20.9629 5.89474 21.3326 5.89474 21.7736C5.89474 22.3703 5.82719 22.9151 5.69211 23.408C5.55702 23.901 5.37895 24.3679 5.15789 24.809C5.2807 24.8609 5.40351 24.8868 5.52632 24.8868H5.89474ZM14.3684 18.6604L10.3158 14.3798L23.5053 0.448299C23.7754 0.162923 24.1132 0.0137499 24.5184 0.000778297C24.9237 -0.0121933 25.2737 0.13698 25.5684 0.448299L27.5579 2.5497C27.8526 2.86102 28 3.22422 28 3.63931C28 4.05441 27.8526 4.41761 27.5579 4.72893L20.9632 11.6947L14.3684 18.6604Z"
      fill="url(#paint0_linear_1423_15323)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1423_15323"
        x1={-6.35782e-8}
        y1={14.0093}
        x2={24.1845}
        y2={18.4206}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0CAECF" />
        <stop offset={1} stopColor="#580F6B" />
      </linearGradient>
    </defs>
  </svg>
);


export default ArtistMenuIcon;